import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';


export default function Attestation({
  onClose, setAppear,
  targetPath, label, header, description
}) {
  const navigate = useNavigate();

  // auto dismiss after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose?.();
      setAppear(false);
    }, 5000);
    return () => clearTimeout(timer);
  }, [onClose]);

  const handleClose = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    onClose?.();
    setAppear(false);
  };

  const handleAction = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate(targetPath);
    setAppear(false);
  };

  return (
    <AnimatePresence >
      <div
        className="position-fixed top-0 start-50 translate-middle-x p-3"
        style={{ zIndex: 1050 }}
      >
        <motion.div
          initial={{ opacity: 0, y: '-100%' }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: '-100%' }}
          transition={{ duration: 0.4 }}
        >
          <div className="toast show bg-dark " role="alert" aria-live="assertive" aria-atomic="true">
            <div className="toast-header bg-dark text-white border-secondary">
              <strong className="me-auto">{header}</strong>
              <button
                type="button"
                className="btn-close ms-2 mb-1 bg-white"
                aria-label="Close"
                onClick={handleClose}
              />
            </div>
            <div className="toast-body">
              <p className={`${label ? "mb-2" : ""} fw-medium text-white `} style={{ fontSize: '15px' }}>{description}</p>
            </div>
            {label ?
              <>
              <hr className="m-0 mb-2 text-white" />
                <button
                  type="button"
                  className="btn btn-secondary btn-sm mb-2 ms-2 py-2 text-dark"
                  onClick={handleAction}
                >
                  {label}
                </button>
              </> : ""}
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
}
